export const ReplacingChargingConnector = ({
  height = 100,
  width = 100,
}: {
  height?: number;
  width?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_b_2954_9193)">
        <circle cx="50" cy="50" r="50" fill="#ebebeb" fillOpacity="0.5" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.3392 28H50.7799C51.6696 28.0013 52.5224 28.3553 53.1514 28.9844C53.7805 29.6135 54.1345 30.4663 54.1359 31.3559V34.861C53.4065 34.9569 52.6908 35.1371 52.003 35.398C51.3518 35.6046 50.7224 35.8744 50.1237 36.2034H37.3562C37.2317 36.2006 37.1072 36.2056 36.9833 36.2183V31.3559C36.9847 30.4663 37.3387 29.6135 37.9677 28.9844C38.5968 28.3553 39.4496 28.0013 40.3392 28ZM48.9286 39.9453C50.8075 38.0664 53.3435 36.9919 56.0003 36.9492C57.9915 36.9492 59.938 37.5396 61.5936 38.6459C63.2493 39.7521 64.5397 41.3245 65.3017 43.1642C66.0637 45.0038 66.2631 47.0281 65.8746 48.9811C65.4861 50.934 64.5273 52.7279 63.1193 54.136C61.7113 55.544 59.9174 56.5028 57.9644 56.8913C56.0114 57.2798 53.9871 57.0804 52.1475 56.3184C50.3078 55.5564 48.7355 54.266 47.6292 52.6103C46.5229 50.9547 45.9325 49.0082 45.9325 47.0169C45.9753 44.3602 47.0497 41.8242 48.9286 39.9453ZM55.3788 52.4216C55.5627 52.5446 55.779 52.6102 56.0003 52.6102C56.2963 52.608 56.5796 52.4895 56.7889 52.2802C56.9982 52.0708 57.1168 51.7875 57.1189 51.4915C57.1189 51.2703 57.0533 51.054 56.9304 50.87C56.8075 50.6861 56.6328 50.5427 56.4284 50.458C56.2239 50.3734 55.999 50.3512 55.782 50.3944C55.565 50.4375 55.3657 50.5441 55.2093 50.7005C55.0528 50.857 54.9463 51.0563 54.9031 51.2733C54.86 51.4903 54.8821 51.7152 54.9668 51.9196C55.0514 52.124 55.1948 52.2987 55.3788 52.4216ZM56.7913 47.808C57.0011 47.5982 57.1189 47.3136 57.1189 47.0169V42.5424C57.1189 42.2457 57.0011 41.9612 56.7913 41.7514C56.5815 41.5416 56.2969 41.4237 56.0003 41.4237C55.7036 41.4237 55.419 41.5416 55.2093 41.7514C54.9995 41.9612 54.8816 42.2457 54.8816 42.5424V47.0169C54.8816 47.3136 54.9995 47.5982 55.2093 47.808C55.419 48.0177 55.7036 48.1356 56.0003 48.1356C56.2969 48.1356 56.5815 48.0177 56.7913 47.808ZM34 41.7967V53.7289C34.0013 54.6186 34.3553 55.4714 34.9844 56.1005C35.6135 56.7295 36.4663 57.0835 37.3559 57.0849H48.9302C47.4732 56.0618 46.2554 54.7349 45.361 53.1956C44.4666 51.6563 43.9167 49.9413 43.7494 48.1688C43.5821 46.3964 43.8013 44.6088 44.3919 42.9293C44.9824 41.2498 45.9303 39.7184 47.1702 38.4408H37.3559C36.4663 38.4422 35.6135 38.7962 34.9844 39.4252C34.3553 40.0543 34.0013 40.9071 34 41.7967ZM48.5429 72H42.5768C42.2801 72 41.9956 71.8821 41.7858 71.6724C41.576 71.4626 41.4582 71.178 41.4582 70.8814V62.4823C40.9997 62.176 40.6238 61.7614 40.3636 61.2752C40.1035 60.7891 39.9671 60.2463 39.9666 59.6949V59.322H51.1531V59.6949C51.1526 60.2463 51.0162 60.7891 50.7561 61.2752C50.4959 61.7614 50.12 62.176 49.6615 62.4823V70.8814C49.6615 71.178 49.5437 71.4626 49.3339 71.6724C49.1241 71.8821 48.8396 72 48.5429 72Z"
        fill="#262626"
      />
      <defs>
        <filter
          id="filter0_b_2954_9193"
          x="-24"
          y="-24"
          width="148"
          height="148"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="12" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_2954_9193"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_2954_9193"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
